import React from "react";
import "./index.css";
import {BackButton} from "../backButton";

export const NotFound = (props) => {
    const reason = props?.location?.state?.reason ?? "Sorry, the page cannot be found."
    return (
        <div className={"notFound"}>
            <div className={"statusCode"}>404</div>
            <div className={"tips"}>{reason}</div>
            <BackButton/>
        </div>
    );
};
